import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Login from './components/login/Login';
import Dashboard from './components/dashboard/Dashboard';
import AddDriver from './components/driver/AddDriver';
import DriverList from './components/driver/DriverList';
import DriverAttendance from './components/driver/DriverAttendance';
import AddSupervisor from './components/supervisor/AddSupervisor';
import SupervisorList from './components/supervisor/SupervisorList';
import WrapperRoute from './components/common/WrapperRoute';
import DriverAttendanceCalendar from './components/driver/DriverAttendanceCalendar';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<WrapperRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/driver/add" element={<AddDriver />} />
        <Route path="/driver/list" element={<DriverList />} />
        <Route path="/driver/attendance" element={<DriverAttendance />} />
        <Route path="/driver/attendance/calendar" element={<DriverAttendanceCalendar />} />
        <Route path="/supervisor/add" element={<AddSupervisor />} />
        <Route path="/supervisor/list" element={<SupervisorList />} />
      </Route>
    </Routes>
  );
}

export default App;
